import { h, FunctionalComponent } from 'preact'

import styles from './styles.scss'

export const DropdownSeparator: FunctionalComponent = () => {
  return <li className={styles['separator']} />
}
